import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ColorScale from '_class/ColorScale';
import moment from 'moment';
import User from '_class/User';
import { getVerdictScale } from 'actions/verdicts';
import { getGroupAbsenceForToday, getSectionAssessmentStatistics } from 'actions/sections';
import { getVerdictsForStudentsInSection } from 'actions/verdicts';
import DateTime from '_class/DateTime';
import { getSectionSubjects } from 'actions/subjects';
import VerdictWidget from 'containers/Verdict/Display/VerdictWidget';
import { Collapsible } from 'UI';
import { Checkbox, Expandable, translate } from '@haldor/ui';
import { Bar, Progress } from 'UI/Graphs';
import { Skeleton, Spinner } from 'UI';
import { Table, Block, Flex, Tabs, Tab, Icon, MultiSelect } from '@haldor/ui';
import './UserMentorSection.scss';

var UserMentorSection = /*#__PURE__*/function (_Component) {
  _inherits(UserMentorSection, _Component);

  var _super = _createSuper(UserMentorSection);

  function UserMentorSection(props) {
    var _this;

    _classCallCheck(this, UserMentorSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_setContainer", function (element) {
      return _this.container = element;
    });

    _defineProperty(_assertThisInitialized(_this), "_setBarColumn", function (element) {
      return _this.barColumn = element;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props = _this.props,
          section = _this$props.section,
          start = _this$props.start,
          end = _this$props.end,
          mentorGroups = _this$props.mentorGroups;

      if (section != null) {
        var students = [];
        section.students.forEach(function (student) {
          students.push(student.userId);
        });

        _this.setState({
          loadingVerdicts: true
        });

        _this.props.getVerdictsForStudentsInSection(students, section.id, start, end).then(function () {
          _this.setState({
            loadingVerdicts: false
          });
        });
      }

      _this.fetchAbsences();

      if (_this.props.scale == null) {
        _this.props.getVerdictScale();
      }

      if (_this.props.subjects == null) {
        _this.setState({
          loadingAssessments: true
        });

        _this.props.getSectionSubjects(section.id, start, end).then(function () {
          _this.setState({
            loadingAssessments: false
          });
        });
      }

      window.addEventListener('hashchange', _this.onHashChange);
      window.addEventListener('resize', _this.resize);

      _this.setState({
        openStudents: _this.props.section.students.map(function (student) {
          return student.userId;
        })
      }, function () {
        _this.resize();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fetchAbsences", function () {
      var _this$props2 = _this.props,
          mentorGroups = _this$props2.mentorGroups,
          section = _this$props2.section;

      if (mentorGroups != null) {
        var listSection = mentorGroups.find(function (g) {
          return g.id == section.id;
        });

        if (listSection != null) {
          if (listSection.absences != null) {
            // Use absences from list instead
            _this.setState({
              absences: listSection.absences
            });

            return true;
          }
        }
      }

      if (section.absences == null) {
        _this.props.getGroupAbsenceForToday(section.id, encodeURIComponent(moment().format()), encodeURIComponent(moment().add(1, 'd').format())).then(function () {
          _this.setState({
            absences: section.absences
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener('resize', _this.resize);
      window.removeEventListener('hashchange', _this.onHashChange);
    });

    _defineProperty(_assertThisInitialized(_this), "onHashChange", function () {
      if (window.location.hash == '#assessments') {
        _this.setState({
          showMenu: true
        });
      } else {
        _this.setState({
          showMenu: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "resize", function () {
      if (_this.barColumn != null && _this.container != null) {
        _this.setState({
          width: _this.container.scrollWidth - _this.barColumn.scrollWidth
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSubjectsChange", function (subjects) {
      _this.setState({
        subjects: subjects
      });

      var _this$props3 = _this.props,
          section = _this$props3.section,
          start = _this$props3.start,
          end = _this$props3.end;

      _this.setState({
        smallLoader: true
      });

      _this.props.getSectionAssessmentStatistics(section.id, start, end, subjects).then(function () {
        _this.resize();

        _this.setState({
          smallLoader: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.start == null || nextProps.end == null) {
        return false;
      }

      var section = _this.props.section;

      if (nextProps.start != _this.props.start || nextProps.end != _this.props.end) {
        var start = nextProps.start,
            end = nextProps.end;
        var students = [];
        section.students.forEach(function (student) {
          students.push(student.userId);
        });

        _this.setState({
          loadingVerdicts: true
        });

        _this.props.getVerdictsForStudentsInSection(students, section.id, start, end).then(function () {
          _this.setState({
            loadingVerdicts: false
          });
        });

        _this.setState({
          loadingAssessments: true
        });

        Promise.all([_this.props.getSectionSubjects(section.id, start, end), _this.props.getSectionAssessmentStatistics(section.id, start, end, _this.state.subjects)]).then(function () {
          _this.resize();

          _this.setState({
            loadingAssessments: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calculateAttendance", function (attendance, student) {
      if (attendance != null) {
        var _translate = _this.props.translate;
        var foundAttendance = null;

        if (attendance != null) {
          foundAttendance = _this.props.attendance.find(function (user_attendance) {
            if (user_attendance != null) {
              return user_attendance.userId == student.id;
            }

            return false;
          });
        }

        if (foundAttendance != null) {
          var _foundAttendance = foundAttendance,
              invalidAbsence = _foundAttendance.invalidAbsence,
              invalidLate = _foundAttendance.invalidLate,
              present = _foundAttendance.present,
              validAbsence = _foundAttendance.validAbsence,
              validLate = _foundAttendance.validLate;
          var total = invalidAbsence + invalidLate + present + validAbsence + validLate;
          var _attendance = {
            'percentage': {
              'attendance': 0,
              'validAbsence': 0,
              'invalidAbsence': 0
            },
            'minutes': {
              'present': present,
              'validAbsence': validAbsence + validLate,
              'invalidAbsence': invalidAbsence + invalidLate
            },
            'display': {
              'present': '0 ' + _translate('minutes').toLowerCase(),
              'validAbsence': '0 ' + _translate('minutes').toLowerCase(),
              'invalidAbsence': '0 ' + _translate('minutes').toLowerCase()
            }
          };

          if (total > 0) {
            _attendance.percentage = {
              attendance: Math.round(present / total * 100 * 10) / 10,
              validAbsence: Math.round((validAbsence + validLate) / total * 100 * 10) / 10,
              invalidAbsence: Math.round((invalidAbsence + invalidLate) / total * 100 * 10) / 10
            };

            if (_attendance.minutes.present > 600) {
              _attendance.display.present = Math.floor(_attendance.minutes.present / 60) + ' ' + _translate('hours').toLowerCase();
            } else {
              _attendance.display.present = _attendance.minutes.present + ' ' + _translate('minutes');
            }

            if (_attendance.minutes.validAbsence > 600) {
              _attendance.display.validAbsence = Math.floor(_attendance.minutes.validAbsence / 60) + ' ' + _translate('hours').toLowerCase();
            } else {
              _attendance.display.validAbsence = _attendance.minutes.validAbsence + ' ' + _translate('minutes').toLowerCase();
            }

            if (_attendance.minutes.invalidAbsence > 600) {
              _attendance.display.invalidAbsence = Math.floor(_attendance.minutes.invalidAbsence / 60) + ' ' + _translate('hours').toLowerCase();
            } else {
              _attendance.display.invalidAbsence = _attendance.minutes.invalidAbsence + ' ' + _translate('minutes').toLowerCase();
            }
          }

          return _attendance;
        }
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "getPercentageFromStatistics", function (items) {
      if (items == null) {
        return 0;
      }

      var percentages = [];
      items.forEach(function (item) {
        var item_total = 0;
        var indexed = [];
        item.statistics.forEach(function (stat) {
          item_total += stat.count;
          indexed.push({
            count: stat.count,
            index: stat.index,
            weight: stat.weight
          });
        });

        for (var i = 0; i <= item_total; i++) {
          indexed.map(function (entry) {
            if (entry.count > 0) {
              percentages.push(entry.weight);
              entry.count = entry.count - 1;
            }

            return entry;
          });
        }
      });
      return Math.round(percentages.reduce(function (a, b) {
        return a + b;
      }, 0) / percentages.length);
    });

    _defineProperty(_assertThisInitialized(_this), "renderAssessmentBar", function (item, index) {
      if (!_this.state.filters.includes(item.type)) {
        return null;
      }

      if (item.statistics != null) {
        var data = [];
        var isEmpty = item.statistics.find(function (stat) {
          return stat.count > 0;
        }) == null;

        if (isEmpty) {
          return null;
        }

        var colors = new ColorScale(item.statistics.length).get();
        item.statistics.map(function (stat) {
          data.push({
            amount: stat.count,
            label: stat.count,
            color: colors[stat.index]
          });
        });
        var line = null;

        if (data.length > 0) {
          line = /*#__PURE__*/React.createElement(Bar, {
            data: data,
            showAmount: true,
            showAllSteps: true
          });
        }

        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "bar-outer-container"
        }, /*#__PURE__*/React.createElement("div", null, _this.props.translate(item.type)), line);
      }

      return /*#__PURE__*/React.createElement("div", null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderGoalBar", function () {
      var percentage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (!_this.state.filters.includes('ASSESSMENTGOAL')) {
        return null;
      }

      if (percentage == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "bar-outer-container"
      }, /*#__PURE__*/React.createElement("div", null, _this.props.translate('ASSESSMENTGOAL')), /*#__PURE__*/React.createElement("div", {
        style: {
          paddingLeft: '.55rem'
        }
      }, /*#__PURE__*/React.createElement(Progress, {
        percentage: percentage,
        label: "".concat(percentage, "%")
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "getCourses", function () {
      var courses = [];

      if (_this.props.sectionVerdicts != null) {
        _this.props.sectionVerdicts.forEach(function (verdict) {
          verdict.courses.forEach(function (course) {
            var inCourses = courses.find(function (c) {
              return c.courseID == course.courseID;
            });

            if (inCourses == null) {
              courses.push(course);
            }
          });
        });
      }

      if (courses.length > 0) {
        courses = courses.sort(function (a, b) {
          return a.courseID > b.courseID ? 1 : 0;
        });
      }

      return courses;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleStudentOpen", function (student) {
      var index = _this.state.openStudents.indexOf(student.userId);

      if (index > -1) {
        _this.setState({
          openStudents: _this.state.openStudents.filter(function (id) {
            return id != student.userId;
          })
        });
      } else {
        _this.setState({
          openStudents: [].concat(_toConsumableArray(_this.state.openStudents), [student.userId])
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleStudentsOpen", function () {
      var active = _this.props.section.students.length == _this.state.openStudents.length;

      if (active) {
        _this.setState({
          openStudents: []
        });
      } else {
        _this.setState({
          openStudents: _this.props.section.students.map(function (student) {
            return student.userId;
          })
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleFilter", function (filter) {
      var index = _this.state.filters.indexOf(filter);

      if (index > -1) {
        _this.setState({
          filters: _this.state.filters.filter(function (id) {
            return id != filter;
          })
        });
      } else {
        _this.setState({
          filters: [].concat(_toConsumableArray(_this.state.filters), [filter])
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getChildHistoricMembers", function (historicMember) {
      var children = _this.props.section.historicMembers.filter(function (el) {
        return el.userId == historicMember.userId && el.relationship == 'child';
      });

      return children.map(function (member) {
        return /*#__PURE__*/React.createElement("div", {
          className: "history-member-row child"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          },
          className: "name"
        }), /*#__PURE__*/React.createElement("div", {
          className: "connected-duration"
        }, /*#__PURE__*/React.createElement("span", null, "".concat(new DateTime(member.startDate).getDateStamp(), " - ").concat(new DateTime(member.endDate).getDateStamp())), member.userRoles.some(function (el) {
          return el == 'OWNER';
        }) ? /*#__PURE__*/React.createElement("div", {
          className: "card-meta",
          style: {
            marginLeft: '1.65rem',
            fontWeight: 500
          }
        }, _this.props.translate('Owner')) : null));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudentRoleIndicator", function (student) {
      if (student == null) {
        return null;
      }

      if (student.userRoles != null && student.userRoles.find(function (role) {
        return role.toUpperCase() == "STUDENT";
      }) == null) {
        var _translate2 = _this.props.translate;
        return /*#__PURE__*/React.createElement(Icon, {
          name: "Alert_Red",
          title: _translate2('Missing student role in school')
        });
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudentRow", function (student) {
      var absences = _this.state.absences;
      var user = new User(student);

      var attendance = _this.calculateAttendance(_this.props.attendance, student);

      var foundValid = null;
      var foundInvalid = null;

      if (absences != null) {
        foundValid = absences.find(function (absence) {
          return absence.user.userId == student.id && absence.type == "VALID_ABSENCE";
        });
        foundInvalid = absences.find(function (absence) {
          return absence.user.userId == student.id && absence.type == "INVALID_ABSENCE";
        });
      }

      return /*#__PURE__*/React.createElement("tr", {
        key: student.id
      }, /*#__PURE__*/React.createElement("td", {
        className: "name"
      }, /*#__PURE__*/React.createElement(Flex, {
        center: true
      }, foundInvalid != null ? /*#__PURE__*/React.createElement("span", {
        style: {
          width: 11,
          height: 11,
          borderRadius: 10,
          display: 'inline-block',
          marginRight: '0.3rem',
          backgroundColor: "#f25252"
        }
      }) : null, foundInvalid == null && foundValid != null ? /*#__PURE__*/React.createElement("span", {
        style: {
          width: 11,
          height: 11,
          borderRadius: 10,
          display: 'inline-block',
          marginRight: '0.3rem',
          backgroundColor: '#FF883E'
        }
      }) : null, /*#__PURE__*/React.createElement(Link, {
        to: "/user/".concat(student.id, "/progress/#attendance")
      }, _this.renderStudentRoleIndicator(user), user.getName()))), /*#__PURE__*/React.createElement("td", null, attendance != null ? /*#__PURE__*/React.createElement(Flex, {
        center: true
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          width: 11,
          height: 11,
          borderRadius: 10,
          display: 'inline-block',
          marginRight: '0.3rem',
          backgroundColor: '#19DB6C'
        }
      }), attendance.percentage.attendance, "% (", attendance.display.present, ")") : /*#__PURE__*/React.createElement(Skeleton, null)), /*#__PURE__*/React.createElement("td", null, attendance != null ? /*#__PURE__*/React.createElement(Flex, {
        center: true
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          width: 11,
          height: 11,
          borderRadius: 10,
          display: 'inline-block',
          marginRight: '0.3rem',
          backgroundColor: '#FF883E'
        }
      }), attendance.percentage.validAbsence, "% (", attendance.display.validAbsence, ")") : /*#__PURE__*/React.createElement(Skeleton, null)), /*#__PURE__*/React.createElement("td", null, attendance != null ? /*#__PURE__*/React.createElement(Flex, {
        center: true
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          width: 11,
          height: 11,
          borderRadius: 10,
          display: 'inline-block',
          marginRight: '0.3rem',
          backgroundColor: '#F25252'
        }
      }), attendance.percentage.invalidAbsence, "% (", attendance.display.invalidAbsence, ")") : /*#__PURE__*/React.createElement(Skeleton, null)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderVerdictTable", function () {
      var courses = _this.getCourses();

      var sortedStudents = _this.props.section.students.sort(function (a, b) {
        return a.lastName.localeCompare(b.lastName);
      });

      if (courses.length < 1) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            margin: '4rem 0 3rem 0'
          },
          className: "text--center color--meta"
        }, _this.props.translate('no-results'));
      }

      return /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, _this.props.translate('name')), courses.map(function (course, i) {
        return /*#__PURE__*/React.createElement("th", {
          key: i
        }, course.title + (course.year != null ? " " + course.year : ''));
      }))), /*#__PURE__*/React.createElement("tbody", null, sortedStudents.map(function (student) {
        return /*#__PURE__*/React.createElement("tr", {
          key: student.userId
        }, /*#__PURE__*/React.createElement("td", {
          className: "name"
        }, /*#__PURE__*/React.createElement(Link, {
          to: "/user/".concat(student.id, "/progress/#verdicts")
        }, _this.renderStudentRoleIndicator(student), student.firstName, " ", student.lastName)), courses.map(function (course, i) {
          var verdict = _this.props.sectionVerdicts.find(function (verdict) {
            if (verdict.userId != student.userId) {
              return false;
            }

            var inCourses = verdict.courses.findIndex(function (co) {
              return co.courseID == course.courseID;
            });

            if (inCourses > -1) {
              return true;
            }

            return false;
          });

          if (verdict == null) {
            return /*#__PURE__*/React.createElement("td", {
              key: i
            }, /*#__PURE__*/React.createElement("div", {
              style: {
                height: 10
              }
            }));
          }

          return /*#__PURE__*/React.createElement("td", {
            key: i,
            style: {
              textAlign: 'center'
            }
          }, /*#__PURE__*/React.createElement(VerdictWidget, {
            displayLabel: false,
            verdict: verdict
          }));
        }));
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderAttendanceTable", function () {
      var sortedStudents = _this.props.section.students.sort(function (a, b) {
        return a.lastName.localeCompare(b.lastName);
      });

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          margin: '-1.4rem -1.7rem'
        }
      }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, _this.props.translate('name')), /*#__PURE__*/React.createElement("th", null, _this.props.translate('attendance')), /*#__PURE__*/React.createElement("th", null, _this.props.translate('valid_absence')), /*#__PURE__*/React.createElement("th", null, _this.props.translate('invalid_absence')))), /*#__PURE__*/React.createElement("tbody", null, sortedStudents.map(_this.renderStudentRow)))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderAssessmentsTable", function () {
      var width = _this.state.width > 0 ? _this.state.width + 'px' : '100%';

      var sortedStudents = _this.props.section.students.sort(function (a, b) {
        return a.lastName.localeCompare(b.lastName);
      });

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          margin: '-1.4rem -1.7rem'
        }
      }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
        ref: _this._setBarColumn
      }, _this.props.translate('name')), /*#__PURE__*/React.createElement("th", {
        style: {
          width: width
        }
      }, _this.props.translate('assessment-overview')))), /*#__PURE__*/React.createElement("tbody", null, sortedStudents.map(function (student) {
        var assessments = null;
        var percentage = 0;

        var open = _this.state.openStudents.includes(student.userId);

        if (_this.props.assessments != null) {
          var _assessments, _assessments$studentS;

          assessments = _this.props.assessments.find(function (assessment) {
            return assessment.studentId == student.userId;
          });
          var goalStatistics = (_assessments = assessments) === null || _assessments === void 0 ? void 0 : (_assessments$studentS = _assessments.studentStatistics) === null || _assessments$studentS === void 0 ? void 0 : _assessments$studentS.filter(function (stat) {
            return stat.type == 'ASSESSMENTGOAL';
          });
          percentage = _this.getPercentageFromStatistics(goalStatistics);
        }

        return /*#__PURE__*/React.createElement("tr", {
          key: student.id
        }, /*#__PURE__*/React.createElement("td", {
          className: "name",
          title: "".concat(_this.props.translate('Connected to group'), " ").concat(new DateTime(student.connectedToSectionDate).getDateStamp())
        }, /*#__PURE__*/React.createElement(Link, {
          to: "/user/".concat(student.id, "/progress/#assessments")
        }, _this.renderStudentRoleIndicator(student), student.firstName, " ", student.lastName)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Expandable, {
          title: "",
          onChange: function onChange() {
            return _this.toggleStudentOpen(student);
          },
          open: open
        }, percentage > 0 ? _this.renderGoalBar(percentage) : null, assessments != null ? assessments.studentStatistics.map(function (item, index) {
          if (item.type == 'MATRIX') {
            return _this.renderAssessmentBar(item, index);
          }

          return null;
        }) : /*#__PURE__*/React.createElement("div", {
          style: {
            height: 23
          }
        }))));
      })))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderExpand", function () {
      var active = _this.props.section.students.length == _this.state.openStudents.length;
      return /*#__PURE__*/React.createElement("div", {
        className: active ? 'expand-all active' : 'expand-all',
        onClick: _this.toggleStudentsOpen
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "ArrowLeft"
      }), " ", active ? _this.props.translate('Close all') : _this.props.translate('Show all'));
    });

    _this.state = {
      subjects: [],
      filters: ['ASSESSMENTGOAL', 'MATRIX'],
      loadingVerdicts: false,
      loadingAssessments: false,
      smallLoader: false,
      width: 0,
      openStudents: [],
      showMenu: true,
      absences: null
    };
    _this.container = null;
    _this.barColumn = null;
    return _this;
  }

  _createClass(UserMentorSection, [{
    key: "render",
    value: function render() {
      var _this$props$section$h,
          _this2 = this,
          _this$props$section$h2,
          _this$props$section$h3;

      (_this$props$section$h = this.props.section.historicMembers) === null || _this$props$section$h === void 0 ? void 0 : _this$props$section$h.forEach(function (member, index) {
        var laterEntries = _this2.props.section.historicMembers.some(function (el, someIndex) {
          return el.userId == member.userId && someIndex > index;
        });

        var earlierEntries = _this2.props.section.historicMembers.some(function (el, someIndex) {
          return el.userId == member.userId && someIndex < index;
        });

        if (laterEntries && !earlierEntries) {
          member.relationship = 'parent';
        } else if (laterEntries && earlierEntries || !laterEntries && earlierEntries) {
          member.relationship = 'child';
        } else {
          member.relationship = null;
        }
      });
      var subjects = this.props.subjects;

      if (subjects != null && subjects.find(function (subject) {
        return subject.id == 0;
      }) == null) {
        subjects.push({
          id: 0,
          title: this.props.translate('Assessments without subjects')
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        ref: this._setContainer,
        className: "list user-mentor"
      }, this.props.renderActions != null ? this.props.renderActions() : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("div", {
        className: "title-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          marginBottom: 0
        }
      }, this.props.translate('Students')), this.state.showMenu ? /*#__PURE__*/React.createElement("div", {
        className: "filter-container"
      }, this.state.smallLoader ? /*#__PURE__*/React.createElement(Spinner, {
        small: true
      }) : null, /*#__PURE__*/React.createElement(Checkbox, {
        label: this.props.translate('MATRIX'),
        onChange: function onChange() {
          return _this2.toggleFilter('MATRIX');
        },
        value: this.state.filters.includes('MATRIX')
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: this.props.translate('ASSESSMENTGOAL'),
        onChange: function onChange() {
          return _this2.toggleFilter('ASSESSMENTGOAL');
        },
        value: this.state.filters.includes('ASSESSMENTGOAL')
      }), subjects != null ? /*#__PURE__*/React.createElement(MultiSelect, {
        displaySelectedCount: false,
        trigger: this.props.translate('Showing') + ' ' + this.state.subjects.length + ' ' + this.props.translate('of') + ' ' + subjects.length,
        options: subjects.map(function (subject) {
          return {
            label: subject.title,
            value: subject.id
          };
        }),
        onChange: this.onSubjectsChange,
        value: this.props.subjects.map(function (subject) {
          return subject.id;
        }),
        selectAllLabel: this.props.translate('Select all')
      }) : null, this.renderExpand()) : null), /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('assessments-header-overview'),
        route: "assessments"
      }, this.state.loadingAssessments ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : this.renderAssessmentsTable()), /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('verdicts'),
        route: "verdicts"
      }, this.state.loadingVerdicts ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          margin: '-1.4rem -1.7rem'
        }
      }, this.renderVerdictTable())), /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('attendance'),
        route: "attendance"
      }, this.renderAttendanceTable())), ((_this$props$section$h2 = this.props.section.historicMembers) === null || _this$props$section$h2 === void 0 ? void 0 : _this$props$section$h2.length) > 0 && /*#__PURE__*/React.createElement("div", {
        className: "previous-members-card"
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: /*#__PURE__*/React.createElement("div", {
          className: "previous-members-title"
        }, this.props.translate('Previous members'))
      }, /*#__PURE__*/React.createElement("div", {
        className: "previous-member-list"
      }, (_this$props$section$h3 = this.props.section.historicMembers) === null || _this$props$section$h3 === void 0 ? void 0 : _this$props$section$h3.map(function (student) {
        return /*#__PURE__*/React.createElement("div", null, student.relationship == 'parent' ? /*#__PURE__*/React.createElement(Collapsible, {
          trigger: /*#__PURE__*/React.createElement("div", {
            className: "history-member-row"
          }, /*#__PURE__*/React.createElement("div", {
            className: "name"
          }, student.displayName), /*#__PURE__*/React.createElement("div", {
            className: "connected-duration"
          }, /*#__PURE__*/React.createElement("span", null, "".concat(new DateTime(student.startDate).getDateStamp(), " - ").concat(new DateTime(student.endDate).getDateStamp())), student.userRoles.some(function (el) {
            return el == 'OWNER';
          }) ? /*#__PURE__*/React.createElement("div", {
            className: "card-meta",
            style: {
              marginLeft: '1.65rem',
              fontWeight: 500
            }
          }, _this2.props.translate('Owner')) : null))
        }, _this2.getChildHistoricMembers(student)) : student.relationship == null ? /*#__PURE__*/React.createElement("div", {
          className: "history-member-row child"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          },
          className: "name"
        }, student.displayName), /*#__PURE__*/React.createElement("div", {
          className: "connected-duration"
        }, "".concat(new DateTime(student.startDate).getDateStamp(), " - ").concat(new DateTime(student.endDate).getDateStamp()))) : null);
      }))))));
    }
  }]);

  return UserMentorSection;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    mentorGroups: state.sections.mentorGroups,
    sectionVerdicts: state.Verdicts.sectionStudents,
    scale: state.Verdicts.scale,
    assessments: state.sections.assessmentStatistics,
    subjects: state.Subjects.section
  };
}

export default connect(mapStateToProps, {
  getGroupAbsenceForToday: getGroupAbsenceForToday,
  getVerdictsForStudentsInSection: getVerdictsForStudentsInSection,
  getVerdictScale: getVerdictScale,
  getSectionAssessmentStatistics: getSectionAssessmentStatistics,
  getSectionSubjects: getSectionSubjects
})(UserMentorSection);